import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '../views/Dashboard.vue';
import DashboardLayout from '../layouts/DashboardLayout';
import { auth } from '@/firebase';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
    component: DashboardLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
      },
      {
        path: '/statistiques',
        name: 'statistiques',
        component: () => import(/* webpackChunkName: "login" */ '../views/Statistiques.vue'),
      },
      {
        path: '/nouveau-client',
        name: 'createClient',
        component: () => import(/* webpackChunkName: "login" */ '../views/CreateClient.vue'),
      },
      {
        path: '/exports',
        name: 'exports',
        component: () => import(/* webpackChunkName: "login" */ '../views/Exports.vue'),
      },
      {
        path: '/modifier-client/:id',
        name: 'editClient',
        component: () => import(/* webpackChunkName: "login" */ '../views/EditClient.vue'),
      },
      {
        path: '/fiche-client/:id',
        name: 'ficheClient',
        component: () => import(/* webpackChunkName: "login" */ '../views/FicheClient.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: {
      requiresVisitor: true,
    },
  },
];

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresVisitor = to.matched.some((record) => record.meta.requiresVisitor);
  const isAuthenticated = auth.currentUser;
  if (requiresAuth && !isAuthenticated) {
    next('/login');
  } else {
    next();
  }
  if (requiresVisitor && isAuthenticated) {
    next('dashboard');
  } else {
    next();
  }
});

export default router;
